import { render } from "./OtpInput.vue?vue&type=template&id=628cfdc6&lang=pug"
import script from "./OtpInput.vue?vue&type=script&setup=true&lang=js"
export * from "./OtpInput.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__